import React, { useState } from 'react';
import { useAuth } from './AuthContext';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await signIn(email, password);
    if (error) setError(error.message);
    setLoading(false);
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-mark">
            <svg viewBox="0 0 34 34" fill="none">
              <rect x="2" y="4" width="20" height="14" rx="2" fill="#0F0F0F"/>
              <rect x="3" y="5" width="18" height="12" rx="1.5" fill="#39D353"/>
              <path d="M6 8h7M6 11h5M6 14h6" stroke="#0F0F0F" strokeWidth="1.5" strokeLinecap="round"/>
              <circle cx="26" cy="22" r="6" fill="#0F0F0F"/>
              <circle cx="26" cy="22" r="4" fill="#39D353"/>
            </svg>
          </div>
          <div className="login-title">D&R Signs</div>
          <div className="login-sub">Tool Inventory System</div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div>
            <label className="login-label">Email address</label>
            <input
              className="login-input"
              type="email"
              placeholder="you@drsigns.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>
          <div>
            <label className="login-label">Password</label>
            <input
              className="login-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          {error && <div className="login-error">{error}</div>}
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div style={{ marginTop: '1.5rem', textAlign: 'center', fontSize: '11px', color: '#5C5C5C' }}>
          Contact your system administrator to get access.
        </div>
      </div>
    </div>
  );
}
